// src/app/pages/TopUpPage/controller/TopUpPageController.ts
import { hapticFeedback } from "@tma.js/sdk";
import type { TokenPackageFromCatalog } from "@/app/data/profilPayment/api/PaymentsApi";

const safeHaptic = (callback: () => void) => {
  try { callback(); } catch {}
};

export interface CheckoutProductPayload {
  productType: 'tokens' | 'subscription';
  productCode: string;
  productId: string;
  productName: string;
  priceRub: number;
  currency: string;         // теперь всегда XTR
  quantityLabel?: string;
  durationLabel?: string;
  features?: string[];
  promoCode?: string;
}

export class TopUpPageController {
  triggerImpact(): void {
    safeHaptic(() => hapticFeedback.impactOccurred("medium"));
  }

  triggerSelection(): void {
    safeHaptic(() => hapticFeedback.selectionChanged());
  }

  mapTokenPackageToCheckout(pack: TokenPackageFromCatalog): CheckoutProductPayload {
    const rub = pack.prices.find(p => p.currency === 'RUB');
    const xtr = pack.prices.find(p => p.currency === 'XTR');

    // Для TELEGRAM всегда XTR, если есть, иначе RUB (на случай других провайдеров)
    const currency = xtr ? 'XTR' : (rub ? 'RUB' : 'XTR');
    const priceRub = rub ? Math.round(rub.amountMinor / 100) : 0;

    return {
      productType: 'tokens',
      productCode: pack.code,
      productId: pack.code,
      productName: pack.title,
      priceRub,
      currency,   // теперь всегда XTR
      quantityLabel: pack.tokenAmount ? `${pack.tokenAmount.toLocaleString()} токенов` : undefined,
    };
  }

  formatPrice(price: number): string {
    const hasFraction = !Number.isInteger(price);
    return `${new Intl.NumberFormat("ru-RU", {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: hasFraction ? 2 : 0,
    }).format(price)} ₽`;
  }
}